export default "/images/6adf60326717c8a1f065af0de329c2b1.avif";